import { render, staticRenderFns } from "./gramlist.vue?vue&type=template&id=c02a8a6a&scoped=true"
import script from "./gramlist.vue?vue&type=script&lang=js"
export * from "./gramlist.vue?vue&type=script&lang=js"
import style0 from "./gramlist.vue?vue&type=style&index=0&id=c02a8a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02a8a6a",
  null
  
)

export default component.exports